module.exports = __webpack_public_path__ + "img/ícone-seta-esquerda-primeiro-cinza.7e4fea43.svg";